import { render, staticRenderFns } from "./ClubSettingsItem.vue?vue&type=template&id=168d8965&lang=html&"
import script from "./ClubSettingsItem.vue?vue&type=script&lang=js&"
export * from "./ClubSettingsItem.vue?vue&type=script&lang=js&"
import style0 from "./ClubSettingsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCombobox,VFlex,VTextField,VTextarea})
